export const SET_MENU_ROUTES = "@SET_MENU_ROUTES";

export const setMenuRoutes = (value: any) => {
  return {
    type: SET_MENU_ROUTES,
    value,
  };
};
